import { davTrace } from './log.js'
export class FileSystemHandler {
    constructor() {
        this.rootHandle = null
    }

    ready() {
        return !!this.rootHandle
    }

    async selectDirectory() {
        try {
            this.rootHandle = await window.showDirectoryPicker()
            davTrace('Directory selected:', this.rootHandle.name)
        } catch (err) {
            console.error('Error selecting directory:', err)
            this.rootHandle = null
            return false
        }

        try {
            let test = await this.rootHandle.getFileHandle(
                '__TEST_READ_WRITE__',
                {
                    create: true,
                }
            )
            const writeable = await test.createWritable()
            writeable.write('testing read + write')
            await writeable.close()

            let f = await test.getFile()
            davTrace('text: ', await f.text())

            try {
                await test.remove()
                davTrace('file removed.')
            } catch (e) {
                console.error('remove: ', { e })
            }

            return this.rootHandle
        } catch (err) {
            console.error('Error testing read/write access:', err)
            this.rootHandle = null
            return false
        }
    }

    async getDirectoryOrFileHandle(handle, name, options) {
        let newHandle
        try {
            newHandle = await handle.getFileHandle(name, options)
        } catch (error) {
            if (
                error.name === 'TypeMismatchError' ||
                error.name === 'NotFoundError'
            ) {
                try {
                    newHandle = await handle.getDirectoryHandle(name, options)
                } catch (error) {
                    console.warn('Error: ', { error })
                    throw error
                }
            } else {
                console.warn({ error })
                throw error
            }
        }
        return newHandle
    }

    async getFileHandle(path, options = {}) {
        const parts = path.split('/').filter(Boolean)
        let handle = this.rootHandle
        davTrace('getFileHandle: ', path, parts, handle, options)

        for (let i = 0; i < parts.length; i++) {
            const part = parts[i]
            const isLast = i === parts.length - 1
            davTrace('--sub', part, handle)

            if (isLast && options.directory) {
                // MKCOL: final segment must be a directory
                handle = await handle.getDirectoryHandle(part, {
                    create: options.create,
                })
            } else if (isLast && options.getDirectory) {
                // Explicit directory lookup (e.g. DELETE parent)
                handle = await handle.getDirectoryHandle(part)
            } else if (!isLast) {
                // Intermediate segments are always directories
                handle = await handle.getDirectoryHandle(part, {
                    create: options.create,
                })
            } else {
                // Final segment, default: try file first, fall back to directory
                handle = await this.getDirectoryOrFileHandle(handle, part, {
                    create: options.create,
                })
            }
        }

        return handle
    }
}